import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';


const EditParameterModal = ({
  open,
  onClose,
  onSave,
  parameterData,
}) => {
  const [paramName, setParamName] = useState('');
  const [paramValue, setParamValue] = useState('');
  const [partnerName, setPartnerName] = useState('');
  const [accountName, setAccountName] = useState('');
  const [partnerAccountId, setPartnerAccountId] = useState('');

  useEffect(() => {
    if (parameterData) {
      setParamName(parameterData.name || '');
      setParamValue(parameterData.value || '');
      setPartnerName(parameterData.partnerName || '');
      setAccountName(parameterData.accountName || '');
      setPartnerAccountId(parameterData.ID || '');
    }
  }, [parameterData]);

  const handleSave = () => {
    onSave({
      ...parameterData,
      name: paramName,
      value: paramValue,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Edit Parameter</DialogTitle>
      <DialogContent dividers>
        <Box mb={2}>
          <TextField fullWidth label='Export Type' value={partnerName} variant='outlined' disabled />
        </Box>
        <Box mb={2}>
          <TextField fullWidth label='Destination Name' value={accountName} variant='outlined' disabled />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label='Partner Account ID'
            value={partnerAccountId}
            variant='outlined'
            disabled // Make it read-only
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label='Parameter Name'
            value={paramName}
            onChange={(e) => setParamName(e.target.value)}
            variant='outlined'
            disabled
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label='Parameter Value'
            value={paramValue}
            onChange={(e) => setParamValue(e.target.value)}
            variant='outlined'
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='outlined'>Cancel</Button>
        <Button onClick={handleSave} variant='contained' color='primary'>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditParameterModal;
